<template>
  <v-row class="signup-container pa-0 ma-0">
    <v-col cols="12" md="8" lg="6" xl="4" class="pa-0">
      <v-fade-transition mode="out-in">
        <v-stepper
          v-model="activeStep"
          class="elevation-0 rounded-0 stepperArea "
          alt-labels
          tile
        >
          <v-toolbar
           :dense="$vuetify.breakpoint.smAndUp ? false : true"
            flat
            class="px-2 elevation-1"
          >
              <img width="35px" height="35px" :src="companyLogo" v-if="companyLogo"/>
            <span class="ml-3 text-h6 grey--text text--darken-3"
              >RED-CRM-X</span>
          </v-toolbar>

          <v-stepper-header
            v-show="activeStep == 2 || activeStep == 3"
            color="primary"
            class="elevation-0"
          >
            <v-stepper-step step="1" :complete="isStep1Complete">
              {{ $t("signup.lbl.identify") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2" :complete="activeStep > 2">
              {{ $t("signup.lbl.terms") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" :complete="activeStep > 3">
              {{ $t("signup.lbl.input_form") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4">
              {{ $t("signup.lbl.complete") }}
            </v-stepper-step>
          </v-stepper-header>

          <!-- 1단계 -->
          <v-stepper-items class="stepperContents">
            <v-stepper-content step="1" class="pa-0">
              <v-container
                class="px-4 px-md-6 py-10 firstStepContaniner overflow-auto "
              >
              
              <v-row justify="center" class="mb-2">
                    <v-col cols="4" v-if="companyLogo"></v-col>
                    <v-col cols="4" v-if="companyLogo"> 
                      <img width="100%" :src="companyLogo"/><img
                    /></v-col>
                    <v-col cols="4" v-if="companyLogo"></v-col>

                    <v-col>
                      <h3
                        class="text-center text-h4 grey--text text--darken-2 pa-0 mb-2"
                      >
                        {{ $t("signup.lbl.signup") }}
                      </h3>
                      <v-card-subtitle
                        class="text-center text-subtitle-1 grey--text text--darken-4 pa-0 "
                      >
                        {{ $t("signup.msg.signup_discription") }}
                      </v-card-subtitle></v-col
                    >
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" class="py-2 ">
                      <!-- 카카오버튼 -->
                      <rc-kakao-signup></rc-kakao-signup></v-col>
                    <v-col cols="12" class="py-2 ">
                      <!-- 본인인증 버튼 -->
                      <rc-customer-identify-check></rc-customer-identify-check>
                    </v-col>
                  </v-row>
              </v-container>
            </v-stepper-content>
            <!-- 2단계 -->
            <v-stepper-content step="2" class="px-4 px-md-6 py-10">
              <rc-terms-step

                :termsStep="termsStep"
                ref="refTermsStep"
              ></rc-terms-step>

              <v-row class="align-end btnArea">
                <v-col cols="4">
                  <v-btn
                    large
                    :x-large="$vuetify.breakpoint.smAndUp ? true : false"
                    width="100%"
                    elevation="0"
                    @click="prevPage()"
                  >
                    <v-icon left>mdi-chevron-left</v-icon>
                    {{ $t("signup.btn.prev") }}
                  </v-btn>
                </v-col>
                <v-col cols="8">
                  <v-btn
                    large
                    :x-large="$vuetify.breakpoint.smAndUp ? true : false"
                    width="100%"
                    color="primary"
                    elevation="0"
                    @click="nextPage()"
                  >
                    {{ $t("signup.btn.next") }}
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- 3단계 -->
            <v-stepper-content step="3" class="px-4 px-md-6 py-10 ">
              <rc-customer-info-form
                v-if="activeStep == 3"
                :identify="identify"
                :identifyType="identifyType"
                :termsList="termsList"
                :requiredInput="requiredInput"
                :selectedInput="selectedInput"
                ref="infoForm"
              ></rc-customer-info-form>

              <v-row>
                <v-col cols="4">
                  <v-btn x-large width="100%" elevation="0" @click="prevPage()">
                    <v-icon left>mdi-chevron-left</v-icon>
                    {{ $t("signup.btn.prev") }}
                  </v-btn>
                </v-col>
                <v-col cols="8">
                  <v-btn
                    x-large
                    width="100%"
                    color="primary"
                    elevation="0"
                    @click="nextPage()"
                  >
                    {{ $t("signup.btn.next") }}
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

            </v-stepper-content>

            <!-- 4단계 -->
            <v-stepper-content step="4" class="px-4 px-md-6 py-10 ">
              <div style="display: flex; justify-content: center;">
                <v-container
                  class="pa-0"
                  style="height:calc(100vh - 80px); flex-direction: column; display: flex; justify-content: center;"
                >
                  <div
                    style=" flex-direction: column; display: flex;"
                    class="mb-2 mb-md-8"
                  >
                    <v-row justify="center" class="mb-2 mb-md-6" v-if="companyLogo">
                      <v-col cols="3"></v-col>
                      <v-col cols="6">
                        <img
                          width="100%"
                          height="min-max"
                          :src="companyLogo"
                        /><img />
                      </v-col>
                      <v-col cols="3"></v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <h3
                          class="text-center text-h4 text-sm-h3 grey--text text--darken-2 pa-0 mb-1 mb-md-2"
                        >
                          {{ $t("signup.lbl.complete_signup") }}
                        </h3>
                        <v-card-subtitle
                          class="text-center text-subtitle-1 grey--text text--darken-4 pa-0 "
                        >
                          {{ $t("signup.msg.complete_discription") }}
                        </v-card-subtitle></v-col
                      >
                    </v-row>
                  </div>

                  <v-card-actions>
                    <v-row justify="center" class="pa-0 ma-0">
                      <v-col cols="12" class="pa-0 ma-0">
                        <v-btn
                          block
                          :x-large="$vuetify.breakpoint.smAndUp ? true : false"
                          @click="returnFirst"
                          large
                          color="primary"
                          elevation="0"
                        >
                          {{ $t("signup.btn.back_first_step") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-container>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import RcCustomerInfoForm from "@/redcrm/components/customer/customer-signup/RcCustomerInfoForm.vue";
import RcTermsStep from "@/redcrm/components/customer/customer-signup/RcTermsStep.vue";
import RcKakaoSignup from "@/redcrm/components/customer/simple-signup/RcKakaoSignup.vue";
import RcCustomerIdentifyCheck from "@/redcrm/components/customer/customer-identify/RcCustomerIdentifyCheck.vue";
import {
  getKakaoToken,
  getKakaoUserInfo,
  restApiKey,
  javascriptKey,
} from "@/redcrm/api/kakaoApi.js";
import {
  $getResData,
  $isUsableIdentifyValue,
  $signupCustomer,
} from "@/redcrm/api/customer.js";
import { $getActiveTermsList, } from "@/redcrm/api/terms.js";
import { $getLogoConfig } from "@/redcrm/api/configs.js";

export default {
  components: {
    RcCustomerInfoForm,
    RcTermsStep,
    RcKakaoSignup,
    RcCustomerIdentifyCheck,
  },
  data() {
    return {
      activeStep: 1,
      isStep1Complete: false,
      isStep2Complete: false,
      identify: null,
      identifyType: "",
      termsList: null,
      termsStep: null,
      signupResult: "",
      companyLogo: "",
      requiredInput: {
        loginId: "",
        loginPw: "",
        custName: "",
        mobileNo: "",
        email: "",
        birthDate: "",
        verifyIdVal: "",
        verifyIdSrc: "",
        genderCode: "",
      },
      selectedInput: {
        foreigner: false,
        zipCode: "",
        address1: "",
        address2: "",
        married: false,
        employee: false,
        hasChildren: false,
        smsAgree: true,
        emailAgree: true,
        pushAgree: true,
        dmAgree: true,
        tmAgree: true,
      },
    };
  },
  methods: {
    returnFirst() {
      window.location.href = window.location.origin + window.location.pathname;
    },
    async nextPage() {
      if (this.activeStep == 2) {
        let result = await this.$refs.refTermsStep.validate();
        if (result) {
          this.termsList = this.$refs.refTermsStep.getTermsValue();
          this.activeStep += 1;
        }
      } else if (this.activeStep == 3) {
        let validate = await this.$refs.infoForm.validate();
        if (validate == false) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth", // "auto" 또는 "smooth"를 사용하여 스크롤 동작 지정
          });
        }

        if (validate) {
          let inputFormData = this.$refs.infoForm.signupCustomer();
          inputFormData.termsAgreeDtos = this.termsList;
          await this.signup(inputFormData);
        }
      }
    },
    async signup(param) {
      try {
        const { data } = await $signupCustomer(param);
        if (data.result != null) {
          this.activeStep += 1;
          this.init();
        }
      } catch (error) {
        const message = error.response.data.message;
        const jsonArray = JSON.parse(message.substring(message.indexOf("[")));
        if (jsonArray[0].messageCode === "400-2") {
          this.$rxSnackbar("warning", this.$t("signup.msg.not_invalid_pw"));
        }
        if (jsonArray[0].messageCode === "400-1") {
          this.$rxSnackbar("warning", this.$t("signup.msg.not_invalid_id"));
        }
        if (jsonArray[0].messageCode === "409-1") {
          this.$rxSnackbar("warning", this.$t("signup.msg.exist_id"));
        }
        if (jsonArray[0].messageCode === "409-2") {
          this.$rxSnackbar("warning", this.$t("signup.msg.exist_ci"));
        }
      }
    },
    init() {
      this.termsList = null;
      this.identify = null;
      this.identifyType = null;
      this.selectedInput = null;
      this.requiredInput = null;
    },

    prevPage() {
      if (this.activeStep == 2) {
        window.location.href =
          window.location.origin + window.location.pathname;
      } else if (this.activeStep == 3) {
        this.activeStep -= 1;
      }
    },
    async query() {
      //url뒤의 queryString의 종류에 따라 본인인증 방식을 나눔
      if (this.$route.query.code !== undefined) {
        await this.setKakaoToken(); //카카오
        if(this.identify){
          await this.isUsableIdentifyValue(this.identify.ci); // 동일 CI 여부 확인
        }
      }
      if (this.$route.query.key !== undefined) {
        await this.getNiceResData(); //NICE
        if (this.identify) {
          await this.isUsableIdentifyValue(this.identify.ci); // 동일 CI 여부 확인
        }
      }
    },
    checkRouteQuery() {
      //url뒤의 queryString 존재 여부에 따라 화면 이동 다르게 처리
      const query = this.$route.query;
      if (Object.keys(query).length !== 0) {
        // this.$route.query의 값이 존재하는 경우
        this.isStep1Complete = true;
        this.activeStep = 2;
      } else {
        // this.$route.query의 값이 없는 경우
        this.isStep1Complete = false;
        this.activeStep = 1;
      }
    },
    async setKakaoToken() {
      //KAKAO 토큰 값 넣어서 유저 정보 가져오기
      var host = window.location.host;
      var pro = window.location.protocol;
      const jsKey = await javascriptKey;
      window.Kakao.init(jsKey.data);
      const key = await restApiKey;
      const { data } = await getKakaoToken(
        this.$route.query.code,
        key.data,
        pro,
        host
      );

      if (data==null){
        this.returnFirst();
      }
      window.Kakao.Auth.setAccessToken(data.access_token);

      await this.setUserInfo(data.access_token);
    },
    async setUserInfo(token) {
      const res = await getKakaoUserInfo(token);
      this.identify = res.data.kakao_account;
      this.identifyType = "KAKAO";
    },
    async getNiceResData() {
      //NICE 유저정보 가져오기
      let params = {
        key: this.$route.query.key,
        iv: this.$route.query.iv,
        encData: this.$route.query.encData,
      };

      const { data } = await $getResData(params);
      this.identify = JSON.parse(data.result);
      this.identifyType = "NICE";
    },
    async isUsableIdentifyValue(ci) {
      //동일 ci존재여부 확인
      try {
        const { data } = await $isUsableIdentifyValue(ci);
        if (data.result == true) {
          alert("이미 가입한 사용자 입니다");
          window.location.href =
            window.location.origin + window.location.pathname;
        }
      } catch (error) {
        this.$rxSnackbar("error", error);
      }
    },
    async getActiveTermsList() {
      const { data } = await $getActiveTermsList();
      this.termsStep = data.result.map((x) => ({ ...x, agreed: false }));
    },
    async getLogoConfig() {
      const { data } = await $getLogoConfig();
      const result = data.result;
      const logoJson = JSON.parse(result.configVal);
      if (logoJson.companyLogo && logoJson.companyLogo.length > 0) {
        this.companyLogo = logoJson.companyLogo;
      }
    },
  },
  async created() {
    this.query(); // NICE,KAKAO 결과값이 있을 경우, 해당 결과값을 identify 담아두는 것
    this.checkRouteQuery();
    await this.getActiveTermsList();
    await this.getLogoConfig();
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "SUIT";
  src: url('~@/redworks/assets/fonts/SUIT-Regular.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}

.signup-container {
  font-family: "SUIT", sans-serif;
  display: flex;
  justify-content: center;
  background-color: #f1f3f5;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
}

.stepperArea {
  height: 100%;
  position: relative;
}
.btnArea {
  width: calc(100% - 24px);
  position: absolute;
  bottom: 76px;
}

.stepperContents {
  box-sizing: border-box;
  height: calc(100% - 83px);
}
.firstStepContaniner{
  position: absolute; 
  top: 50%;
  transform: translate(0,-50%);}
</style>
